var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCohortPercentileIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 7.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 7.5,
    stroke: "#BBC3F3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.1667 18.0013C24.1667 17.8172 24.3159 17.668 24.5 17.668H25.3334C25.5175 17.668 25.6667 17.8172 25.6667 18.0013C25.6667 18.1854 25.5175 18.3346 25.3334 18.3346H24.5C24.3159 18.3346 24.1667 18.1854 24.1667 18.0013Z",
    fill: "#5FEDD3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8333 17.3346C12.8333 20.1881 15.1465 22.5013 18 22.5013C20.8534 22.5013 23.1666 20.1881 23.1666 17.3346C23.1666 14.4812 20.8534 12.168 18 12.168C15.1465 12.168 12.8333 14.4812 12.8333 17.3346Z",
    fill: "#6C7DE5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3333 14.8333C18.3333 14.6492 18.1841 14.5 18 14.5C17.8159 14.5 17.6666 14.6492 17.6666 14.8333V15.1667H17.0203C16.6424 15.1667 16.3359 15.3155 16.1282 15.5551C15.9264 15.7878 15.8333 16.0874 15.8333 16.375C15.8333 16.6626 15.9264 16.9622 16.1282 17.195C16.3359 17.4345 16.6424 17.5833 17.0203 17.5833H17.6666V18.6667H16.4123C16.2282 18.6667 16.079 18.8159 16.079 19C16.079 19.1841 16.2282 19.3333 16.4123 19.3333H17.6666V19.6667C17.6666 19.8508 17.8159 20 18 20C18.1841 20 18.3333 19.8508 18.3333 19.6667V19.3333H18.9796C19.3576 19.3333 19.664 19.1845 19.8717 18.945C20.0736 18.7122 20.1666 18.4126 20.1666 18.125C20.1666 17.8374 20.0736 17.5378 19.8717 17.3051C19.664 17.0656 19.3576 16.9167 18.9796 16.9167H18.3333V15.8333H19.4675C19.6515 15.8333 19.8008 15.6841 19.8008 15.5C19.8008 15.3159 19.6515 15.1667 19.4675 15.1667H18.3333V14.8333ZM17.6666 15.8333H17.0203C16.8291 15.8333 16.7087 15.9032 16.6319 15.9918C16.5492 16.0872 16.5 16.2251 16.5 16.375C16.5 16.5249 16.5492 16.6628 16.6319 16.7582C16.7087 16.8468 16.8291 16.9167 17.0203 16.9167H17.6666V15.8333ZM18.3333 17.5833V18.6667H18.9796C19.1708 18.6667 19.2912 18.5968 19.3681 18.5082C19.4508 18.4128 19.5 18.2749 19.5 18.125C19.5 17.9751 19.4508 17.8372 19.3681 17.7418C19.2912 17.6532 19.1708 17.5833 18.9796 17.5833H18.3333Z",
    fill: "#5FEDD3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 21.832H15.5V23.4848C15.5 24.1368 15.8292 24.6654 16.2353 24.6654H19.7647C20.1708 24.6654 20.5 24.1368 20.5 23.4848V21.832Z",
    fill: "#8595F7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6666 24.668H16.3333C16.3333 25.5885 17.0795 26.3346 18 26.3346C18.9204 26.3346 19.6666 25.5885 19.6666 24.668Z",
    fill: "#9CA9FB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 9.66797C18.1841 9.66797 18.3333 9.8172 18.3333 10.0013V10.8346C18.3333 11.0187 18.1841 11.168 18 11.168C17.8159 11.168 17.6666 11.0187 17.6666 10.8346V10.0013C17.6666 9.8172 17.8159 9.66797 18 9.66797Z",
    fill: "#5FEDD3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3333 18.0013C10.3333 17.8172 10.4825 17.668 10.6666 17.668H11.5C11.6841 17.668 11.8333 17.8172 11.8333 18.0013C11.8333 18.1854 11.6841 18.3346 11.5 18.3346H10.6666C10.4825 18.3346 10.3333 18.1854 10.3333 18.0013Z",
    fill: "#5FEDD3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.681 12.9336C11.8111 12.8034 12.0222 12.8034 12.1524 12.9336L12.7416 13.5228C12.8718 13.653 12.8718 13.8641 12.7416 13.9942C12.6114 14.1244 12.4004 14.1244 12.2702 13.9942L11.681 13.405C11.5508 13.2748 11.5508 13.0637 11.681 12.9336Z",
    fill: "#5FEDD3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.319 12.9336C24.1888 12.8034 23.9778 12.8034 23.8476 12.9336L23.2583 13.5228C23.1282 13.653 23.1282 13.8641 23.2583 13.9942C23.3885 14.1244 23.5996 14.1244 23.7297 13.9942L24.319 13.405C24.4492 13.2748 24.4492 13.0637 24.319 12.9336Z",
    fill: "#5FEDD3"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCohortPercentileIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/cohort-percentile-icon.35b04ec087699bf152140035b3508ced.svg";